import { PropertyCompanyAddressType } from '../../../../common/validations'

/**
 * From Kenno-UI
 * Postal address single line formatting. In case of missing address, returns an empty string.
 * Examples:
 * Postiosoite 1 A 2, Joensuu
 * Postiosoite 1 A 2, 01234 Joensuu
 *
 * @param postalAddress postalAddress object
 */
export const formatPostalAddress = (
  address: PropertyCompanyAddressType
): string => {
  // Note! streetAddressLine2 is not taken into account, because it doesn't belong to Finnish standards.
  const addr = `${address.streetAddressLine1}, ${address.postalCode} ${address.city}`
  return addr
}
